export default {
  title: 'Panel'
}
